import React, { useState } from 'react';
import { Mail, Send } from 'lucide-react';
import { contactInfo } from '../mock';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Toaster } from '../components/ui/sonner';
import { toast } from 'sonner';

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock form submission
    console.log('Form submitted:', formData);
    toast.success('Message sent successfully! We will get back to you soon.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: ''
    });
  };

  return (
    <div className="min-h-screen bg-white">
      <Toaster />
      
      {/* Page Header */}
      <section className="bg-gradient-to-br from-purple-50 via-white to-purple-50 py-8 md:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-purple-900 mb-6">Get in Touch</h1>
            <p className="text-xl text-gray-700 leading-relaxed">
              Have questions or want to learn more about Jagratha SHG? <br/> We'd love to hear from you!
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Information */}
            <div className="space-y-8">
              <div>
                <h2 className="text-3xl font-bold text-purple-900 mb-6">Contact Information</h2>
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  Feel free to reach out to us through any of these channels. We're here to help and answer any questions you may have.
                </p>
              </div>

              <div className="space-y-6">
                {/* Email */}
                <Card className="border-purple-100 hover:shadow-lg transition-all duration-300">
                  <CardContent className="p-6">
                    <div className="flex items-start space-x-4">
                      <div className="bg-purple-100 p-3 rounded-full flex-shrink-0">
                        <Mail className="text-purple-700" size={24} />
                      </div>
                      <div>
                        <h3 className="font-semibold text-purple-900 mb-1">Email</h3>
                        <a 
                          href={`mailto:${contactInfo.email}`}
                          className="text-gray-700 hover:text-purple-700 transition-colors duration-200"
                        >
                          {contactInfo.email}
                        </a>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                {/* Phone */}
                {/* <Card className="border-purple-100 hover:shadow-lg transition-all duration-300">
                  <CardContent className="p-6">
                    <div className="flex items-start space-x-4">
                      <div className="bg-purple-100 p-3 rounded-full flex-shrink-0">
                        <Phone className="text-purple-700" size={24} />
                      </div>
                      <div>
                        <h3 className="font-semibold text-purple-900 mb-1">Phone</h3>
                        <a 
                          href={`tel:${contactInfo.phone}`}
                          className="text-gray-700 hover:text-purple-700 transition-colors duration-200"
                        >
                          {contactInfo.phone}
                        </a>
                      </div>
                    </div>
                  </CardContent>
                </Card> */}

                {/* Address */}
                {/* <Card className="border-purple-100 hover:shadow-lg transition-all duration-300">
                  <CardContent className="p-6">
                    <div className="flex items-start space-x-4">
                      <div className="bg-purple-100 p-3 rounded-full flex-shrink-0">
                        <MapPin className="text-purple-700" size={24} />
                      </div>
                      <div>
                        <h3 className="font-semibold text-purple-900 mb-1">Address</h3>
                        <p className="text-gray-700">{contactInfo.address}</p>
                      </div>
                    </div>
                  </CardContent>
                </Card> */}
              </div>

              {/* Office Hours */}
              {/* <Card className="bg-gradient-to-br from-purple-50 to-white border-purple-100">
                <CardContent className="p-6">
                  <h3 className="font-semibold text-purple-900 mb-3 text-lg">Office Hours</h3>
                  <div className="space-y-2 text-gray-700">
                    <p><span className="font-medium">Monday - Friday:</span> 9:00 AM - 5:00 PM</p>
                    <p><span className="font-medium">Saturday:</span> 9:00 AM - 1:00 PM</p>
                    <p><span className="font-medium">Sunday:</span> Closed</p>
                  </div>
                </CardContent>
              </Card> */}
            </div>

            {/* Contact Form */}
            <div>
              <Card className="border-purple-100 shadow-lg">
                <CardContent className="p-8">
                  <h2 className="text-2xl font-bold text-purple-900 mb-6">Send us a Message</h2>
                  <form onSubmit={handleSubmit} className="space-y-6" netlify>
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                        Your Name *
                      </label>
                      <Input
                        id="name"
                        name="name"
                        type="text"
                        required
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Enter your full name"
                        className="w-full border-purple-200 focus:border-purple-500 focus:ring-purple-500"
                      />
                    </div>

                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                        Email Address *
                      </label>
                      <Input
                        id="email"
                        name="email"
                        type="email"
                        required
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="your.email@example.com"
                        className="w-full border-purple-200 focus:border-purple-500 focus:ring-purple-500"
                      />
                    </div>

                    <div>
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                        Phone Number
                      </label>
                      <Input
                        id="phone"
                        name="phone"
                        type="tel"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="+91 98765 43210"
                        className="w-full border-purple-200 focus:border-purple-500 focus:ring-purple-500"
                      />
                    </div>

                    <div>
                      <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                        Your Message *
                      </label>
                      <Textarea
                        id="message"
                        name="message"
                        required
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="Tell us how we can help you..."
                        rows={6}
                        className="w-full border-purple-200 focus:border-purple-500 focus:ring-purple-500"
                      />
                    </div>

                    <Button 
                      type="submit"
                      className="w-full bg-purple-600 hover:bg-purple-700 text-white py-6 text-lg rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl"
                    >
                      Send Message <Send className="ml-2" size={20} />
                    </Button>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* Map or Additional Info Section */}
      <section className="py-16 bg-gradient-to-br from-purple-50 to-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="text-3xl font-bold text-purple-900 mb-4">Visit Us</h2>
            <p className="text-lg text-gray-700">
              We welcome you to visit our office and meet our team. Please call ahead to schedule an appointment.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};
